// eslint-disable-next-line no-unused-vars
import React, { memo, useCallback, useState, useEffect } from 'react';
import { stringify } from 'query-string';
import { useTranslation } from 'react-i18next';

import useRouter from 'Hooks/useRouter';
import useProducts from 'Hooks/useProducts';
import { NWPagination } from 'Components/shared';

const ToolbarFooter = memo(() => {
  const { data } = useProducts();
  const { totalPages, totalRecords, recordsPerPage = 20 } = data || {};
  const { push, location, query } = useRouter();
  const { t } = useTranslation();
  const currentPerPage = parseInt(query?.count || recordsPerPage, 10) || 20;
  const [currentPage, setPage] = useState(parseInt(query?.page || 1, 10));

  const handleOnChange = value => {
    const payload = {
      ...query
    };
    const newPage = parseInt(value.selected, 10) + 1;
    if (newPage === 1) {
      delete payload.page;
    } else {
      payload.page = newPage;
    }
    push({
      pathname: location.pathname,
      search: stringify(payload)
    });
  };

  const hrefBuilder = useCallback(
    page => stringify({
      ...query,
      page
    }),
    [query]
  );

  useEffect(() => {
    if (currentPage !== query?.page) {
      setPage(parseInt(query?.page, 10));
    }
  }, [query?.page]);

  return (
    <NWPagination
      page={ currentPage || 1 }
      itemsPerPage={ currentPerPage || 20 }
      itemsCount={ totalRecords || 0 }
      pageCount={ totalPages || 0 }
      hrefBuilder={ hrefBuilder }
      onPageChange={ handleOnChange }
      itemsName={ t('common.pages.products') }
    />
  );
});

ToolbarFooter.displayName = 'ToolbarFooterContainer';

export default ToolbarFooter;
